import { useRouteMatch } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Colors } from '../../../../themes/colors';
import { FormCard } from '../shared/FormCard';
import { InfoRow } from '../shared/InfoRow';
import { useProfessionalResume } from './hooks/useProfessionalResume';
import { ExperienceField } from './components/ExperienceField';
import { EducationField } from './components/EducationField';
import { SummaryField } from './components/SummaryField';
import { createLoadingSelector } from '../../../../apis/selectors';

const loadingSelector = createLoadingSelector(['FETCH_CURRENT_USER']);

export const ProfessionalResume = () => {
  const match = useRouteMatch();
  const professionalId = match.params.id;

  const isInitialLoading = useSelector((state) => loadingSelector(state));
  const user = useSelector((state) => state.users.currentUser);

  const [isEditing, setIsEditing] = useState(false);

  const {
    data,
    isLoading,
    formValues,
    invalidForm,
    resetForm,
    handleChange,
    handleExperienceChange,
    handleEducationChange,
    handleSaveResume,
    updateResume,
  } = useProfessionalResume(professionalId);

  const onEditClick = () => {
    setIsEditing(true);
  };

  const onCancelClick = () => {
    setIsEditing(false);
    resetForm();
  };

  const onSaveClick = () => {
    setIsEditing(false);
    handleSaveResume();
  };

  if (isInitialLoading || isLoading || updateResume.isPending) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
        <Spinner
          animation="border"
          role="status"
          variant="info"
          style={{
            height: 30,
            width: 30,
            marginLeft: 20,
            marginTop: 10,
          }}
        />
      </div>
    );
  }

  return (
    <FormCard title="GoTu Resume" style={{ maxWidth: '850px', marginTop: '40px' }}>
      <div>
        <InfoRow style={{ borderColor: Colors.divider }}>
          <span className="semi-bold">First Name:</span>
          <span>{data?.professionalFirstName || user?.first_name}</span>
        </InfoRow>
        <InfoRow style={{ borderColor: Colors.divider }}>
          <span className="semi-bold">Last Name:</span>
          <span>{data?.professionalLastName || user?.last_name}</span>
        </InfoRow>
        <InfoRow style={{ borderColor: Colors.divider }}>
          <span className="semi-bold">Email:</span>
          <span>{data?.professionalEmail || user?.email_id}</span>
        </InfoRow>
        <InfoRow style={{ borderColor: Colors.divider }}>
          <span className="semi-bold">Phone:</span>
          <span>{data?.professionalPhone || user?.contact_number}</span>
        </InfoRow>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
        <span className="f-18 bold">About You</span>
        <span className="f-16 bold mt-3">Tell us about yourself</span>
        <SummaryField
          summary={data?.summary}
          summaryForm={formValues?.summary}
          isEditing={isEditing}
          onChange={handleChange}
        />
      </div>

      <div style={{ height: '1px', backgroundColor: Colors.divider }} />

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span className="f-18 bold">Professional Experience</span>
        <ExperienceField
          experiences={data?.experiences}
          experiencesForm={formValues?.experiences}
          isEditing={isEditing}
          onChange={handleExperienceChange}
        />
      </div>

      <div style={{ height: '1px', backgroundColor: Colors.divider }} />

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span className="f-18 bold">Highest Level of Education</span>
        <EducationField
          educations={data?.education}
          educationsForm={formValues?.educations}
          isEditing={isEditing}
          onChange={(index, field, value) => {
            handleEducationChange(index, field, value);
          }}
        />
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 50 }}>
        {isEditing ? (
          <div style={{ display: 'flex', alignSelf: 'center', gap: 10 }}>
            <button
              type="button"
              className="btn btn-danger"
              style={{ width: 100 }}
              onClick={onCancelClick}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-info"
              style={{ width: 100 }}
              onClick={onSaveClick}
              disabled={invalidForm}
            >
              Save
            </button>
          </div>
        ) : (
          <button
            type="button"
            className="btn btn-info"
            style={{ width: 150, alignSelf: 'center' }}
            onClick={onEditClick}
          >
            Edit
          </button>
        )}
      </div>
    </FormCard>
  );
};
